export default __webpack_public_path__ + "static/media/co2.a1df4a5c.svg";